import { memo } from 'react'
import { Link } from 'react-router-dom'
import { TrophyIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import MilestoneBadges from './MilestoneBadges'

/**
 * ActivityStatsSection - Compact user stats row + badges
 * Replaced the 4-column grid with a single inline row to reduce panel height.
 * @idempotent @atomic
 */
const ActivityStatsSection = memo(function ActivityStatsSection({ 
  stats, 
  statsLoading, 
  favoriteCount,
  entityCount
}) {
  const { t } = useTranslation()

  if (statsLoading) return null

  const sightings = stats?.totalSightings || 0
  const confirmations = stats?.confirmationsGiven || 0

  return (
    <div className="space-y-2">
      {/* Compact stat pills + leaderboard link */}
      <div className="flex items-center justify-between px-1">
        <div className="flex items-center gap-3">
          <span className="text-xs text-gray-500">
            <span className="font-semibold text-gray-800">{sightings}</span> {t('profile.sightings', 'spots')}
          </span>
          <span className="text-gray-300">·</span>
          <span className="text-xs text-gray-500">
            <span className="font-semibold text-gray-800">{confirmations}</span> {t('profile.confirmed', 'confirmed')}
          </span>
          {favoriteCount > 0 && (
            <>
              <span className="text-gray-300">·</span>
              <span className="text-xs text-gray-500">
                <span className="font-semibold text-gray-800">{favoriteCount}</span> {t('profile.favorites', 'favorites')}
              </span>
            </>
          )}
        </div>
        <Link
          to="/leaderboard"
          className="flex items-center gap-1 text-xs text-primary hover:text-primary-700 font-medium transition-colors"
        >
          <TrophyIcon className="h-3.5 w-3.5" />
          {t('leaderboard.viewLeaderboard', 'Leaderboard')}
        </Link>
      </div>

      {/* Badges */}
      <MilestoneBadges
        totalSightings={sightings}
        totalConfirmations={confirmations}
        favoriteCount={favoriteCount}
      />
    </div>
  )
})

export default ActivityStatsSection
